
import React, { useEffect } from 'react';
// import $ from "jquery";
import { Routes, Route } from "react-router-dom";
import $ from "jquery";
import { Suspense } from 'react';

const Home = React.lazy(() => import('./pages/Home/Home.jsx'))
const Tournament = React.lazy(() => import('./pages/Tournament/Tournament.jsx'))
const Blogs = React.lazy(() => import('./pages/Blog/Blogs.jsx'))
const AdminPanel = React.lazy(() => import('./pages/AdminPanel/AdminPanel.jsx'))
const Schedule = React.lazy(() => import('./pages/Schedule/Schedule.jsx'))
const LeaderboardNoEvent = React.lazy(() => import('./pages/Leaderboard/Leaderboard_NoEvent.jsx'))
const Profile = React.lazy(() => import('./pages/Profile/Profile.jsx'))
const BlogPost = React.lazy(() => import('./pages/BlogPost/BlogPost.jsx'))
const Cities = React.lazy(() => import('./pages/Cities/Cities.jsx'))
const Redirect = React.lazy(() => import('./pages/Redirect/Redirect.jsx'))
const ElectionsPage = React.lazy(() => import('./pages/ElectionsPage/ElectionsPage.jsx'))
const TermsAndConditions = React.lazy(() => import('./pages/TermsAndConditions/TermsAndConditions.jsx'))
const HowToRegister = React.lazy(() => import('./pages/HowToRegister/HowToRegister.jsx'))
const CitySelection = React.lazy(() => import('./pages/CitySelection/CitySelection.jsx'))
const CandidateApplicaton = React.lazy(() => import('./pages/CandidatePage/CandidateApplication.jsx'))
const CityComponent = React.lazy(() => import('./pages/Cities/SingleCity.jsx'));
const LeaderboardEvent = React.lazy(() => import('./pages/Leaderboard/Corporate_Leaderboard.jsx'));
const WorldCupLeaderboard = React.lazy(() => import('./pages/Leaderboard/WorldCup_Leaderboard.jsx'));
const JIATMTLeaderboard = React.lazy(() => import('./pages/Leaderboard/JumpIntoAction_Leaderboard.jsx'));
const WorldCupT20Leaderboard = React.lazy(() => import('./pages/Leaderboard/WorldCupT20_Leaderboard.jsx'));
const ArenasLeaderboard = React.lazy(() => import('./pages/Leaderboard/Arenas_Leaderboard.jsx'));
const MeetupLeaderboard = React.lazy(() => import('./pages/Leaderboard/Meetup_Leaderboard.jsx'));
const InternsLeaderboard = React.lazy(() => import('./pages/Leaderboard/Interns_Leaderboard.jsx'));

function App() {

  useEffect(() => {
  function preloader() {
      $('#preloader').delay(0).fadeOut();
    };

    $(window).on('load', function () {

      preloader();

    });

  },[])


  return (
    <div className="App">
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />}/>
          <Route path="/schedule" element={<Schedule />} />
          <Route path='/leaderboard' element={<LeaderboardNoEvent />} />
          <Route path='/grouptable' element={<LeaderboardEvent />} />
          <Route path='/how-to-register' element={<HowToRegister />} />
          <Route path="/tournament" element={<Tournament />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/blogs/:permalink' element={<BlogPost />} />
          <Route path='/profile' >
            <Route path=":team_id" element={<Profile />} />
            <Route path="" element={<Profile />} />
          </Route>
          <Route path="/redirect" element={<Redirect />} />
          <Route path="/city-selection" element={<CitySelection />} />
          <Route path="/candidate-application" element={<CandidateApplicaton />} />
          <Route path='/elections' element={<ElectionsPage />} />

          <Route path="/cities">
            {}
            <Route path=":city_id" element = {<CityComponent/> }/>
            <Route path="" element={<Cities/>} />
          </Route>
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/:id" element={<AdminPanel />} />
          <Route path="/corporate/leaderboard">
           <Route path=":tournamentId" element = {<LeaderboardEvent/> }/>
            </Route>
          <Route path="/path-of-legends/leaderboard" element = { <WorldCupLeaderboard/> }/>
          <Route path="/jumpintoaction/leaderboard" element = { <JIATMTLeaderboard/> }/>
          <Route path="/worldconquest/leaderboard" element = { <WorldCupT20Leaderboard/> }/>
          <Route path="/arenas/leaderboard" element = { <ArenasLeaderboard/> }/>
          <Route path="/meetup/leaderboard" element = { <MeetupLeaderboard/> }/>
          <Route path="/interns/leaderboard" element = { <InternsLeaderboard/> }/>
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
